import { useCallback, useEffect } from 'react'

import { AdminTaskResponse, getRenewalTasks } from 'core'

import useQueryRequest from './useQueryRequest'

const useRenewalTasks = (
  initialValue = undefined,
  automaticallyLoad: boolean = true,
): [AdminTaskResponse[] | null, boolean, () => Promise<void>] => {
  const [tasks, isLoading, sendQueryRequest] = useQueryRequest<AdminTaskResponse[]>(initialValue)

  const reloadTasks = useCallback(async () => {
    await sendQueryRequest(() => getRenewalTasks())
  }, [])

  useEffect(() => {
    if (automaticallyLoad) {
      ;(async () => {
        await reloadTasks()
      })()
    }
  }, [automaticallyLoad])

  return [tasks, isLoading, reloadTasks]
}

export default useRenewalTasks
